import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { Title } from '../General/Title';
import InfoRow from './InfoRow';
import { StockInfo } from '../Product/StockInfo';
import { BigButtonWithRequest } from '../Product/BigButtonWithRequest';
import { PriceInfo } from './PriceInfo';
import { CountSetter } from './CountSetter';
import { MinAmountInfoText } from '../Cart/Items/MinAmountInfoText';

interface Props {
  inPackage: number | null;
  price: number;
  currency: string;
  unit: string;
  onStock: number;
  addToRequest: any;
  count: number;
  addToCart: any;
  handleCountChange: (newValue) => void;
  user: any;
  mocPrice?: string;
  sale?: string;
  b2bDiscount?: string;
  unpackingCost: number;
  storesInfo: any;
}

function RightUpper({
  inPackage,
  price,
  currency,
  unit,
  onStock,
  addToRequest,
  addToCart,
  handleCountChange,
  count,
  user,
  mocPrice,
  sale,
  b2bDiscount,
  unpackingCost,
  storesInfo,
}: Props) {
  const isB2B = user && user.b2b;
  const pricesText = isB2B ? __('Cena bez DPH') : __('Cena s DPH');
  const totalPriceText = isB2B ? __('Spolu bez DPH') : __('Spolu s DPH');
  const step = inPackage ? inPackage : unit === 'Mks' ? 0.001 : 1;
  const trueCount = unit === 'Mks' ? count * 1000 : count;
  const showMinPackageInfo = inPackage && inPackage > 0 && inPackage > count;
  const totalPrice = price ? (price * count).toFixed(2) : '';
  const oldPrice = b2bDiscount
    ? (+totalPrice + +b2bDiscount * trueCount).toFixed(2)
    : null;

  const priceWithUnpacking = showMinPackageInfo
    ? (unpackingCost + +totalPrice).toFixed(2)
    : totalPrice;
  const minimalPrice = +priceWithUnpacking > 0.3 ? priceWithUnpacking : '0.3';
  const rightUpperContent = () => {
    return (
      <>
        {inPackage ? (
          <InfoRow title={__('Balenie')} value={`${inPackage} ${unit}`} />
        ) : null}
        {mocPrice ? (
          <InfoRow
            title={__('Doporučená MOC cena')}
            value={`${mocPrice} ${currency} / ${unit}`}
          />
        ) : null}
        {sale ? (
          <InfoRow title={__('Zľava')} value={`${sale} ${currency}`} />
        ) : null}
        {price ? (
          <InfoRow
            title={pricesText}
            value={`${price} ${currency} / ${unit}`}
            hasBorderTop={false}
          />
        ) : null}
        <CountStockWrapper>
          <CountSetter
            step={step}
            unit={unit}
            count={count}
            onChange={handleCountChange}
          />
          <StockInfo
            mobileNoExactCount={true}
            withoutExactStockCount={false}
            justify={'flex-end'}
            onStock={onStock}
            unit={unit}
            bottomMargin={false}
            storesInfo={storesInfo}
            moveLeft={true}
          />
        </CountStockWrapper>
        {price ? (
          <PriceInfo
            price={minimalPrice}
            currency={currency}
            text={totalPriceText}
            oldPrice={oldPrice!}
          />
        ) : null}
        {showMinPackageInfo ? (
          <MinimumPackageWrapper>
            <MinAmountInfoText borderBottom={0} />
          </MinimumPackageWrapper>
        ) : null}
        <BigButtonWithRequest
          onRequestClick={addToRequest}
          onButtonClick={addToCart}
          disabled={onStock === 0}
        />
      </>
    );
  };
  return (
    <>
      <DesktopWrapper>{rightUpperContent()}</DesktopWrapper>
      <MobileWrapper>{rightUpperContent()}</MobileWrapper>
    </>
  );
}

const Wrapper = styled(FlexCol)`
  width: 100%;
  padding: ${rem(24)};
  max-width: ${rem(448)};
  box-shadow: ${({ theme }) => theme.boxShadow.default};
  border: ${({ theme }) => theme.borders.secondary};
  border-radius: ${rem(4)};

  ${({ theme }) => theme.mediab.l925`
    padding: 0;
    border: 0;
    box-shadow: none;
  `}
`;

const MinimumPackageWrapper = styled.div`
  margin-bottom: ${rem(24)};
`;

const DesktopWrapper = styled(Wrapper)`
  ${({ theme }) => theme.mediab.l925`
   display: none;
  `}
`;

const MobileWrapper = styled(Wrapper)`
  display: none;

  ${({ theme }) => theme.mediab.l925`
   display: flex;
   margin-bottom: ${rem(26)};
  `}
`;

const CountStockWrapper = styled(FlexRowCenterVertical)`
  justify-content: space-between;
  margin-top: ${rem(24)};
  width: 100%;
  margin-bottom: ${rem(16)};
`;

export { RightUpper };
